import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CatalogFilter } from 'src/app/services/catalog.service';
import { HorizontalSignalingRetroreflectionMeasurement, TrafficSignRetroreflection } from 'src/models';
import * as Leaflet from 'leaflet';
import { SystemModuleEnum, VerticalSignalizationTypeEnum } from 'src/enumerators';


@Component({
  selector: 'app-sidebar-map',
  templateUrl: './sidebar-map.component.html',
  styleUrls: ['./sidebar-map.component.css']
})
export class SidebarMapComponent implements OnInit {

  @Input() sidebarIdSelected = '';
  @Input() selectedTask: Task;
  @Input() sidebarType: SystemModuleEnum;;
  @Input() kilometerSelected = 0;
  @Input() retroMeasurementList: Array<HorizontalSignalingRetroreflectionMeasurement> = [];
  @Input() retroMeasurementTrafficList: Array<TrafficSignRetroreflection> = [];
  @Input() googleMap: google.maps.Map;
  @Input() currentTeamVehicle;
  @Input() signList: Array<any> = [];
  @Input() taskList: Array<Task> = [];
  @Input() checkOptionsFilter;
  @Input() catalogFilter: CatalogFilter;
  @Input() warrantyStatus;
  @Input() retroStatus;
  @Input() signalingTypes: Array<any> = [];
  @Input() signTypeFilterFn?: (sign: any) => boolean;
  @Input() signWarrantyFilterFn?: (sign: any) => boolean;
  @Input() signRetroFilterFn?: (sign: any) => boolean;
  @Output() changeIdEmitter = new EventEmitter<string>(); // Emite os valores para o componente pai;

  systemModuleEnum = SystemModuleEnum;

  constructor() { }

  ngOnInit(): void {
  }

  handleIdSelected(id) {
    this.sidebarIdSelected = id;
    this.changeIdEmitter.emit(id);
  }

}
